import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logoPc from "../../assets/images/logo-header.webp";
import logoMobile from "../../assets/images/logo-header.webp";
import LanguageDropdown from "../LanguageDropdown/LanguageDropdown";
import DarkMode from "../darkMode";
import useMediaQuery from "../../helpers/MediaQuery";
import React, { useState } from "react";
import "./header.css";
import OnlineUsersBadge from "../onlineUsersBadge";
const Header = () => {
  const matches = useMediaQuery("(max-width:767px)");
  const { t } = useTranslation();
  const lang = localStorage.getItem("i18nextLng");
  const [showMenu, setShowMenu] = useState(false);

  const toggleMenu = () => setShowMenu((prev) => !prev);

  return (
    <header
      className="header fade-down"
      style={{ flexDirection: lang === "ar" ? "row-reverse" : "row" }}
      id={t("home_path")}
    >
      <nav
        className="navbar container"
        style={{ direction: lang === "ar" ? "rtl" : "ltr" }}
      >
        {/* --- Logo --- */}
        <div className="logo">
          <Link to="/" className="logo-link">
            <img
              src={!matches ? logoPc : logoMobile}
              alt={t("logo_alt")}
              width="48"
              height="48"
              className="logo-image"
            />
            <span className="logo-name">Imene Yahiaoui</span>
          </Link>
        </div>

        {/* --- Desktop Menu --- */}
        {!matches ? (
          <ul className="nav-list">
            <li>
              <Link to={t("home_path")}>{t("home_title")}</Link>
            </li>
            <li>
              <Link to={t("skills_path")}>{t("skills_title")}</Link>
            </li>
            <li>
              <Link to={t("solotion_path")}>{t("solotion_title")}</Link>
            </li>
            <li>
              <Link to={t("portfolio_path")}>{t("portfolio_title")}</Link>
            </li>
            <li>
              <Link to={t("contact_path")}>{t("contact_title")}</Link>
            </li>
            <li>
              <DarkMode />
            </li>
            <li>
              <LanguageDropdown />
            </li>
            <li className="hidden xl:block">
              <OnlineUsersBadge />
            </li>
          </ul>
        ) : (
          <>
            <button
              className={`menu-btn ${showMenu ? "active" : ""}`}
              onClick={toggleMenu}
              aria-label="Menu principal"
              aria-expanded={showMenu}
              aria-controls="mobile-menu"
              onKeyDown={(event) => { if (event.key === "Escape") setShowMenu(false); }}
            >
              <span className="bar"></span>
              <span className="bar"></span>
              <span className="bar"></span>
            </button>

            <div id="mobile-menu" onKeyDown={(event) => { if (event.key === "Escape") { setShowMenu(false); document.querySelector('.menu-btn')?.focus(); } }} inert={showMenu ? undefined : ""} className={`side-menu ${showMenu ? "open" : ""}`}>
              <ul className="mobile-nav slide-up">
                <li>
                  <Link to={t("home_path")} onClick={toggleMenu}>
                    {t("home_title")}
                  </Link>
                </li>
                <li>
                  <Link to={t("skills_path")} onClick={toggleMenu}>
                    {t("skills_title")}
                  </Link>
                </li>
                <li>
                  <Link to={t("solotion_path")} onClick={toggleMenu}>
                    {t("solotion_title")}
                  </Link>
                </li>
                <li>
                  <Link to={t("portfolio_path")} onClick={toggleMenu}>
                    {t("portfolio_title")}
                  </Link>
                </li>
                <li>
                  <Link to={t("contact_path")} onClick={toggleMenu}>
                    {t("contact_title")}
                  </Link>
                </li>
                <li>
                  <OnlineUsersBadge />
                </li>
              </ul>

              <div className="mobile-actions fade-in">
                <DarkMode />
                <LanguageDropdown />
              </div>
            </div>
          </>
        )}
      </nav>
    </header>
  );
};

export default Header;
